import { apiSlice } from './api';
import { ResponseBody } from '../types/common';

export const guestApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGuestLink: builder.query({
      query: (link) => `common/guest/project/link/${link}`,
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getGuestToken: builder.mutation<
      { accessToken: string; refreshToken: string },
      void
    >({
      query: () => ({
        url: `common/guest/login`,
        method: 'POST',
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    validateSharedLink: builder.mutation({
      query: (data) => ({
        url: `common/guest/project/link/validate`,
        method: 'POST',
        body: data,
      }),
    }),
    getResourceLink: builder.query({
      query: (link) => `common/guest/resource/link/${link}`,
      transformResponse: (res: ResponseBody) => res.data,
    }),
    validateResourceLink: builder.mutation({
      query: (data) => ({
        url: `common/guest/resource/link/validate`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetGuestLinkQuery,
  useGetGuestTokenMutation,
  useValidateSharedLinkMutation,
  useGetResourceLinkQuery,
  useValidateResourceLinkMutation,
} = guestApiSlice;
